import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import { translate } from 'react-i18next';
import { accountRoles, creditorRegistrationActions } from '../../../common/enums';
import {
  CreditorUserProfile,
  DebtorUserProfile,
  ExecutorUserProfile,
} from '../../../features/account-management/components/profile';

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 6,
  },
};

@translate()
@Form.create()
export default class UserProfile extends Component {
  static propTyes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    isUpdating: PropTypes.bool.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit, account } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit({
          profileData: {
            nameFirst: account.nameFirst,
            nameLast: account.nameLast,
            email: account.email,
            ...values
          }
        });
      }
    });
  };

  render() {
    const { account, isUpdating, form, t } = this.props;

    return (
      <Spin spinning={isUpdating}>
        <Form onSubmit={this.handleSubmit}>
          {account.role === accountRoles.DEBTOR && (
            <DebtorUserProfile account={account} isEditable={false} form={form} />
          )}

          {account.role === accountRoles.CREDITOR && (
            <div>
              <CreditorUserProfile
                account={account}
                isEditable={
                  account.registrationAction === creditorRegistrationActions.UPDATE_PROFILE
                }
                form={form}
                t={t}
              />
              {account.registrationAction === creditorRegistrationActions.UPDATE_PROFILE && (
                <Form.Item {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit" size="small">
                    {t('Uložiť')}
                  </Button>
                </Form.Item>
              )}
            </div>
          )}
          {account.role === accountRoles.EXECUTOR && (
            <div>
              <ExecutorUserProfile
                account={account}
                isEditable={true}
                form={form}
                t={t}
              />
              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" size="small">
                  {t('Uložiť')}
                </Button>
              </Form.Item>
            </div>
          )}
        </Form>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-profile/components/UserProfile.js